import { ImageApiUrl, PdfApiUrl } from "./Additional";

export const fileConverterHandler = async (File, Id, FolderName) => {
    const form = new FormData();

    form.append("file", File);
    form.append("foldername", `Job/${FolderName}`);
    form.append("filename", `${FolderName}-${Id}`);

    let res = await fetch(PdfApiUrl, {
      method: "POST",
      body: form,
    });
    let result = await res.json();
    return result.Message.replace(process.env.REACT_APP_FILE_S3_PATH_URL, "");
  };
 export  const imageConverterHandler = async (File, Id, FolderName) => {
    const form = new FormData();

    form.append("file", File);
    form.append("foldername", `Job/${FolderName}`);
    form.append("filename", `${FolderName}-${Id}`);
    let res = await fetch(ImageApiUrl, {
      method: "POST",
      body: form,
    });
    let result = await res.json();
    return result.Message.replace(process.env.REACT_APP_FILE_S3_PATH_URL, "");

    // fetch(, {
    //   method: "POST",
    //   body: form,
    // })
    //   .then((res) => res.json())
    //   .then((result) => {
    //     setImagePreviewUrl(result?.Message);
    //   });
  };